import { render } from "./call-feedback-form.vue?vue&type=template&id=059bb882&scoped=true"
import script from "./call-feedback-form.vue?vue&type=script&lang=js"
export * from "./call-feedback-form.vue?vue&type=script&lang=js"

import "./call-feedback-form.vue?vue&type=style&index=0&id=059bb882&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059bb882"]])

export default __exports__